__turbopack_context__.v({
  "hamburger": "d9Vn_G_hamburger",
  "hamburger_line": "d9Vn_G_hamburger_line",
  "is_open": "d9Vn_G_is_open",
  "mobile_menu_button": "d9Vn_G_mobile_menu_button",
});
